import Loadable from 'react-loadable';
import { ModuleLoadingPage } from '@agora/agora-common/Loading';

const Market = Loadable({
  loader: () => import('./MarketContainer'),
  timeout: 60000,
  loading: ModuleLoadingPage,

});

export default Market;
